// Confirmation dialogs for the master Catalog tab. Both use the STUI popup skeleton.
import { useState } from 'react';
import { X } from 'lucide-react';
import StuiSelect from '../../components/common/StuiSelect';

/**
 * A yes/no dialog for an action that writes. `busy` disables both buttons while the action runs;
 * `confirmDisabled` disables only the confirm button (nothing picked yet); `danger` paints the
 * confirm button red.
 */
export function ConfirmModal({ title, children, confirmLabel = 'OK', danger = false, busy = false, confirmDisabled = false, onConfirm, onClose }) {
  return (
    <div className="stui-modal-overlay">
      <div className="stui-modal stui-modal-md">
        <div className="stui-modal-header">
          <span className="stui-modal-title">{title}</span>
          <button className="stui-modal-close" onClick={onClose} disabled={busy} title="Close"><X size={20} /></button>
        </div>
        <div className="stui-modal-body">{children}</div>
        <div className="stui-modal-footer">
          <button className="stui-btn stui-btn-secondary" onClick={onClose} disabled={busy}>Cancel</button>
          <button className={`stui-btn ${danger ? 'stui-btn-danger' : 'stui-btn-primary'}`} onClick={onConfirm} disabled={busy || confirmDisabled}>
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

const KEEP = '';

/**
 * Promote one project Index Sheet into the catalog, choosing its catalog status. A sheet already
 * in the catalog keeps its status unless another is picked; a new one lands Unreviewed by default.
 */
export function PromoteModal({ database, row, statuses = [], busy = false, onPromote, onClose }) {
  const inCatalog = row.catalogId != null;
  const [status, setStatus] = useState(inCatalog ? KEEP : 'Unreviewed');

  return (
    <ConfirmModal
      title={`Promote ${row.indexSheet}`}
      confirmLabel="Promote"
      busy={busy}
      onClose={onClose}
      onConfirm={() => onPromote(status === KEEP ? null : status)}
    >
      <div className="stui-field-group stui-mb-md">
        <label className="stui-field-label">Catalog status</label>
        <StuiSelect className="stui-select" value={status} onChange={e => setStatus(e.target.value)} disabled={busy}>
          {inCatalog && <option value={KEEP}>Keep current ({row.catalogStatus || 'blank'})</option>}
          {statuses.map(s => <option key={s} value={s}>{s}</option>)}
        </StuiSelect>
      </div>
      <p className="stui-hint">
        {inCatalog
          ? `The catalog's ${row.indexSheet} is refreshed from ${database}.`
          : `${row.indexSheet} is added to the catalog from ${database}.`}
        {row.manufacturerCode ? ` Manufacturer ${row.manufacturerCode} is linked, or added when the catalog does not have it.` : ''}
      </p>
      {row.dsConfig != null && (
        <p className="stui-hint">
          {`Datasheet ${row.dsIndex} becomes the catalog's current revision and is marked Published. `}
          {`Its ${row.valueCount} value${row.valueCount === 1 ? '' : 's'} replace the catalog's values on that revision; values the catalog holds for other revisions stay.`}
        </p>
      )}
    </ConfirmModal>
  );
}
